export default "__VITE_ASSET__DY0ldg6A__"